<template>
  <v-row no-gutters>
    <v-col>
      <v-card>
        <v-card-text class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Приват 24"
            search-label="Пошук за призначенням платежу, ЄРДПОУ, назвою"
            search-field
            clearable
            :loading="loading"
            btn-label="Отримати"
            @getSearch="getSearch"
            @add="getData"
          >
            <template v-slot:filters>
              <v-row class="px-1 py-0">
                <v-col
                  cols="5"
                  class="py-0"
                >
                  <DateRangePicker
                    :start.sync="startDate"
                    :end.sync="endDate"
                    :filled="false"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <CustomTextField
                    v-model="accountNumber"
                    value="123"
                    label="Номер рахунку"
                    flat
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:totals>
              <v-row no-gutters>
                <v-spacer />
                <v-col
                  cols="3"
                  class="d-flex justify-end"
                >
                  <v-card-text class="subtitle-1 text-right pa-0">
                    Сумма:&nbsp;
                  </v-card-text>
                  <v-card-text class="title text-right pa-0 pr-4">
                    {{ totalAmount | decimal }}
                  </v-card-text>
                </v-col>
              </v-row>
            </template>
          </DataListHeading>
        </v-card-text>

        <SimpleTable
          :headers="headers"
          :loading="loading"
          :items-per-page="rowsCount"
          :items="displayedItems"
        />
      </v-card>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="setPages()"
          :total-visible="10"
          color="red lighten-2"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import SimpleTable from "@/components/story/SimpleTable";
import headers from "./headers.js";
import * as integrationsApi from "@/backend/integrationsApi.js";
import DataListHeading from "@/components/DataListHeading.vue";
import moment from "moment";
moment.locale("uk");

export default {
  components: {
    DateRangePicker,
    SimpleTable,
    DataListHeading,
  },
  data: () => ({
    accountNumber: "UA323807750000026007056103050",
    startDate: "",
    endDate: "",
    items: [],
    loading: false,
    search: "",
    page: 1,
  }),
  computed: {
    isNumberAndDatesFilled() {
      return this.accountNumber && this.startDate && this.endDate;
    },
    headers() {
      return headers;
    },
    totalAmount() {
      return (
        this.items &&
        this.items.reduce((acc, item) => {
          return acc + +item.amountInNationalCurrency;
        }, 0)
      );
    },
    filteredItems() {
      const items = this.items;

      if (this.search) {
        const reasons = items.filter((item) =>
          item.reasonForPayment
            .toUpperCase()
            .includes(this.search.toUpperCase())
        );

        const taxCodes = items.filter((item) =>
          item.reasonForPayment.includes(this.search)
        );

        const names = items.filter((item) =>
          item.contractPartnerName
            .toUpperCase()
            .includes(this.search.toUpperCase())
        );

        return [...new Set([...reasons, ...taxCodes, ...names])];
      }

      return items;
    },
    rowsCount() {
      return Math.floor((window.innerHeight - 300) / 55);
    },
    displayedItems() {
      return this.paginate(this.filteredItems);
    },
  },
  watch: {
    isNumberAndDatesFilled: {
      handler(val) {
        if (val) {
          this.getData();
        }
      },
      deep: true,
    },
    filteredItems() {
      this.setPages();
    },
  },
  created() {
    this.endDate = this.moment().format("YYYY-MM-DD");
    this.startDate = this.moment().subtract(2, "days").format("YYYY-MM-DD");
  },
  methods: {
    async getData() {
      this.loading = true;
      this.items = await integrationsApi.fetchPrivatTransactions(this.accountNumber, {
        startDate: this.startDate,
        endDate: this.endDate,
      });
      this.loading = false;
    },
    getSearch(search) {
      this.search = search;
    },
    paginate(items) {
      const page = this.page;
      const perPage = this.rowsCount;
      const from = page * perPage - perPage;
      const to = page * perPage;
      return items.slice(from, to);
    },
    setPages() {
      if (this.rowsCount === null || this.filteredItems === null) {
        return 0;
      }

      return Math.ceil(this.filteredItems.length / this.rowsCount);
    },
  },
};
</script>
